/* Kleine Videoschleifen im ganzen Theme (snippets/rs-schleife; Denny 23.10.2026: „mit so kleinen GIFs arbeiten … hier
   eins, da eins“). Jede <video class="rs-schleife" data-film> liegt über ihrem Standbild. Erst nach load, erst nach der
   ersten Bedienung (Scrollen, Tippen, Maus, Taste) und erst, wenn mindestens ein Viertel davon zu sehen ist, bekommt sie
   ihre Quelle und spielt stumm in Schleife; außer Sicht und im Hintergrund-Tab hält sie an. Mit dem ersten Bild blendet
   sie über dem Standbild ein (Klasse rs-schleife--an). Die Bedienung als Bedingung hält den Seitenaufbau frei: Eine
   Schleife im ersten Bildschirm (FAQ-Seite) blendete sonst nach load ein und kostete Speed Index (Messung 23.10.2026).
   Bei reduzierter Bewegung, html.ohne-bewegung, Save-Data, 2g oder ohne IntersectionObserver lädt nichts, das Standbild
   bleibt. */
(function () {
  if (window.rsSchleifen) return;
  window.rsSchleifen = true;
  var netz = navigator.connection || {};
  var ruhig = document.documentElement.classList.contains('ohne-bewegung') ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (ruhig || netz.saveData === true || /2g$/.test(netz.effectiveType || '') || !('IntersectionObserver' in window)) return;

  var ANLAESSE = ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];

  function los() {
    var filme = Array.prototype.slice.call(document.querySelectorAll('video.rs-schleife[data-film]'));
    if (!filme.length) return;
    var sichtbar = new WeakMap();
    var bedient = false;
    function spielen(film) {
      if (!bedient || document.hidden) return;
      if (!film.getAttribute('src')) {
        film.muted = true;
        film.addEventListener('playing', function () { film.classList.add('rs-schleife--an'); }, { once: true });
        film.src = film.getAttribute('data-film');
      }
      var versuch = film.play();
      if (versuch && versuch.catch) versuch.catch(function () {});
    }
    function ersteBedienung() {
      if (bedient) return;
      bedient = true;
      ANLAESSE.forEach(function (art) { window.removeEventListener(art, ersteBedienung, true); });
      filme.forEach(function (film) { if (sichtbar.get(film)) spielen(film); });
    }
    ANLAESSE.forEach(function (art) { window.addEventListener(art, ersteBedienung, { capture: true, passive: true }); });
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var an = e.isIntersecting && e.intersectionRatio >= 0.25;
        sichtbar.set(e.target, an);
        if (an) spielen(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: [0, 0.25] });
    filme.forEach(function (film) { beobachter.observe(film); });
    document.addEventListener('visibilitychange', function () {
      filme.forEach(function (film) {
        if (document.hidden) { if (!film.paused) film.pause(); }
        else if (sichtbar.get(film)) spielen(film);
      });
    });
  }
  if (document.readyState === 'complete') los();
  else window.addEventListener('load', los, { once: true });
})();
